import { Component } from '@angular/core';
import { ResetLeftContainer } from '../../../../components/public-user-component/auth/reset-password-component/reset-left-container/reset-left-container';
import { ResetRightContainer } from '../../../../components/public-user-component/auth/reset-password-component/reset-right-container/reset-right-container';

@Component({
  selector: 'app-reset-password',
  imports: [ResetLeftContainer, ResetRightContainer],
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.scss',
})
export class ResetPassword {}
